export const vattenfallUrl = (value) => {
  const regex = new RegExp(process.env.VUE_APP_VATTENFALL_SHAREPOINT_REGEX, 'i')
  return value ? regex.test(value) : true
}

export const sumEqual = (value, fieldName, conditionField) => (parts, contract) => {
  let sum = Number(parts.reduce((acc, curr) => acc + Number(curr[fieldName]), 0).toFixed(2))
  // Ignore sum checking if multi currency contract
  if (contract.isMultiCurrency) {
    sum = 100
  }
  return !conditionField && !contract[conditionField] ? true : sum === value
}

export const sumLowerThan = (field, max) => (items, a, b) => {
  const sum = items.reduce((acc, curr) => acc + Number(curr[field]), 0)
  return (Math.round(sum * 100) / 100) <= max
}

export const date = (date) => {
  return date ? !isNaN(new Date(date)) : true
}

export const maxValueAsSumOfSubMilestones = (price, milestone) => {
  if (milestone.existingMilestone && milestone.existingMilestone.subMilestones && milestone.existingMilestone.subMilestones.length) {
    const subMilestonesSum = milestone.existingMilestone.subMilestones.reduce((acc, curr) => acc + (curr.paymentAmountCents || 0), 0)
    return Number(price) >= subMilestonesSum
  }
  if (milestone.subMilestones && milestone.subMilestones.length && !milestone.multiCurrencyMilestone) {
    const subMilestonesSum = milestone.subMilestones.reduce((acc, curr) => acc + (curr.paymentAmountCents || 0), 0)
    return Number(price) >= subMilestonesSum
  }
  return true
}

export const maxValueAsValueOfPart = (price, milestone) => {
  if (milestone.parentMilestoneId && milestone.part && !milestone.variationId && milestone.part.signedPriceCents) {
    return price <= milestone.part.signedPriceCents
  }
  return true
}

export const minValueOrNullForCondition = (minValue, conditionField) => {
  return (value, item) => {
    if (conditionField && item[conditionField]) {
      return value === null || value === undefined || isNaN(value)
    }
    const isVariationOrLiquidatedDamage = item.liquidatedDamageId || item.variationId
    return isVariationOrLiquidatedDamage || value >= minValue
  }
}
export const minValueOrMultiCurrencyMilestone = (minValue) => {
  return (value, item) => {
    if (item.multiCurrencyMilestone) {
      return item.multiCurrencyMilestone
    }
    return value >= minValue
  }
}
export const maxValueOrNullForCondition = (maxValue, conditionField) => {
  return (value, item) => {
    if (conditionField && item[conditionField]) {
      return value === null || value === undefined
    }
    return value <= maxValue
  }
}
export const requiredForField = (fieldName, fieldValue) => (value, item) => {
  return item[fieldName] === fieldValue ? !!value : true
}

export const requiredWhenExpiryDate = (value, item) => {
  return item.expiryDate ? !!value : true
}

export const requireIfNotMultiCurrency = () => (form) => {
  return !form.isMultiCurrency
}
